import * as React from 'react';

import InfoBadge16 from './InfoBadge16';

export const infoBadge16 = () => <InfoBadge16 />;

export default {
    title: 'Icon|Line|InfoBadge16',
    component: InfoBadge16,
    parameters: {
        notes: "`import InfoBadge16 from 'box-ui-elements/es/icon/line/InfoBadge16';`",
    },
};
